import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { post } from '../apiService';
import { ListCustomFieldsResponse } from './../../types/custom-fields/types';

export const listCustomFields = async (
  clientId: string,
  tableName: string
): Promise<{ data: ListCustomFieldsResponse; loading: boolean }> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }

  const url = `resourceMatrix/customfields/list?customerId=${customer}`;
  let loading = true;

  try {
    const body = {
      clientId: clientId,
      tableName: tableName,
    };
    const responseData = await post(url, body);
    const data = responseData as ListCustomFieldsResponse;
    loading = false;
    return { data, loading };
  } catch (error) {
    loading = false;
    throw new Error('Failed to fetch custom fields list');
  }
};
